// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3D2MW","button":"style_button__3cZEf","answer":"style_answer__2ONKu","answer--isVisible":"style_answer--isVisible__1it0U"};